import { render, staticRenderFns } from "./organizations-list.vue?vue&type=template&id=72976eec&scoped=true&"
import script from "./organizations-list.vue?vue&type=script&lang=js&"
export * from "./organizations-list.vue?vue&type=script&lang=js&"
import style0 from "./organizations-list.vue?vue&type=style&index=0&id=72976eec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72976eec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72976eec')) {
      api.createRecord('72976eec', component.options)
    } else {
      api.reload('72976eec', component.options)
    }
    module.hot.accept("./organizations-list.vue?vue&type=template&id=72976eec&scoped=true&", function () {
      api.rerender('72976eec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organizations/organizations-list.vue"
export default component.exports